function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.64271 11.4375C7.24271 8.91218 7.83071 6.38551 8.45204 3.86551C8.86404 2.20018 9.53871 1.74151 11.1707 2.13218C14.544 2.93884 17.9054 3.79484 21.264 4.66284C22.6894 5.03218 23.1707 5.84284 22.8347 7.28818C21.604 12.5202 20.3587 17.7442 19.0947 22.9668C18.7614 24.3468 17.9774 24.8562 16.6254 24.5295C13.1267 23.6868 9.63338 22.8042 6.14804 21.9002C4.85071 21.5642 4.44404 20.7602 4.78271 19.2775C5.38004 16.6602 6.02004 14.0508 6.64271 11.4375Z",
  fill: "#9F9F32"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.0398 16.8134C11.6411 14.2881 12.2278 11.7587 12.8491 9.24007C13.2611 7.57474 13.9358 7.11474 15.5678 7.50674C18.9398 8.3134 22.3024 9.1694 25.6584 10.0387C27.0838 10.4081 27.5691 11.2161 27.2278 12.6654C26.0011 17.8961 24.7544 23.1201 23.4891 28.3427C23.1558 29.7227 22.3744 30.2321 21.0211 29.9041C17.5211 29.0614 14.0291 28.1801 10.5411 27.2761C9.24643 26.9401 8.83843 26.1374 9.1771 24.6534C9.7771 22.0347 10.4171 19.4254 11.0398 16.8134Z",
  fill: "#F5F500"
});

var SvgDoubleYellowCards = function SvgDoubleYellowCards(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubleYellowCards, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doubleYellowCards.666423dd.svg";
export { ForwardRef as ReactComponent };